import { render, staticRenderFns } from "./TdPriority.vue?vue&type=template&id=ae2ae498&scoped=true&"
import script from "./TdPriority.vue?vue&type=script&lang=js&"
export * from "./TdPriority.vue?vue&type=script&lang=js&"
import style0 from "./TdPriority.vue?vue&type=style&index=0&id=ae2ae498&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2ae498",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VList,VMenu,VRow})
